import React, { useEffect, useState } from 'react';
import Home from './Home';
import ForwardCalculator from './ForwardCalculator';
import ReverseCalculator from './ReverseCalculator';
import About from './About';
import Privacy from './Privacy';
import PensionGuide from './PensionGuide';
import KakaoAdBanner from './KakaoAdBanner';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [showSideAd, setShowSideAd] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(min-width: 1280px)').matches;
  });
  const [showInlineMobileAd, setShowInlineMobileAd] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(max-width: 900px)').matches;
  });

  useEffect(() => {
    const sideAdQuery = window.matchMedia('(min-width: 1280px)');
    const inlineMobileAdQuery = window.matchMedia('(max-width: 900px)');
    const handleSideAdChange = (event) => setShowSideAd(event.matches);
    const handleInlineMobileAdChange = (event) => setShowInlineMobileAd(event.matches);

    if (sideAdQuery.addEventListener) {
      sideAdQuery.addEventListener('change', handleSideAdChange);
      inlineMobileAdQuery.addEventListener('change', handleInlineMobileAdChange);
    } else {
      sideAdQuery.addListener(handleSideAdChange);
      inlineMobileAdQuery.addListener(handleInlineMobileAdChange);
    }

    return () => {
      if (sideAdQuery.removeEventListener) {
        sideAdQuery.removeEventListener('change', handleSideAdChange);
        inlineMobileAdQuery.removeEventListener('change', handleInlineMobileAdChange);
      } else {
        sideAdQuery.removeListener(handleSideAdChange);
        inlineMobileAdQuery.removeListener(handleInlineMobileAdChange);
      }
    };
  }, []);

  const nav = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'forward':  return <ForwardCalculator showInlineMobileAd={showInlineMobileAd} />;
      case 'reverse':  return <ReverseCalculator showInlineMobileAd={showInlineMobileAd} />;
      case 'about':    return <About />;
      case 'privacy':  return <Privacy />;
      case 'guide':    return <PensionGuide onNavigate={nav} />;
      default:         return <Home onNavigate={nav} showInlineMobileAd={showInlineMobileAd} />;
    }
  };

  const navBtn = (page, label) => (
    <button
      onClick={() => nav(page)}
      className={currentPage === page ? 'lb-nav-active' : ''}
    >
      {label}
    </button>
  );

  return (
    <div>
      <header className="lb-header">
        <div className="lb-header-inner">
          <nav className="lb-nav" aria-label="주요 메뉴">
            {navBtn('home', '홈')}
            {navBtn('forward', '일반 계산기')}
            {navBtn('reverse', '역산 계산기')}
            {navBtn('guide', '연금 가이드')}
            <a href="https://beaver-pension.com" target="_blank" rel="noopener noreferrer">
              메인사이트 →
            </a>
          </nav>
        </div>
      </header>

      <main className="calc-page-shell">
        <div className="calc-page-main">
          {renderPage()}
        </div>
        {showSideAd && (
          <aside className="calc-ad-rail" aria-label="광고">
            <KakaoAdBanner placement="desktop" />
          </aside>
        )}
      </main>

      <footer className="lb-footer">
        <div className="lb-footer-inner">
          <div>
            <strong>라떼비버 노후연금 계산기</strong><br />
            calc.beaver-pension.com
          </div>
          <div className="lb-footer-links">
            <button onClick={() => nav('privacy')}>개인정보처리방침</button>
            <button onClick={() => nav('about')}>서비스 소개</button>
            <a href="mailto:contact@beaver-pension.com">문의하기</a>
            <span>© 2026 Latte Beaver. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
